import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import { authApi } from '../../api/auth';

type Status = 'verifying' | 'success' | 'error';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<Status>('verifying');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setErrorMsg('Link inválido — token não encontrado.');
      setStatus('error');
      return;
    }

    authApi
      .verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((err: unknown) => {
        const msg =
          (err as { response?: { data?: { error?: { message?: string } } } })
            ?.response?.data?.error?.message ?? 'Link inválido ou expirado.';
        setErrorMsg(msg);
        setStatus('error');
      });
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#0A0A0F] flex items-center justify-center px-6">
      <div className="w-full max-w-md text-center">
        <Link to="/" className="inline-flex items-center gap-3 mb-12 cursor-pointer">
          <img src={logo} alt="Escala Equipe" className="w-8 h-8 object-contain" />
          <span className="text-white font-bold text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>Escala Equipe</span>
        </Link>

        {status === 'verifying' && (
          <>
            <div className="w-16 h-16 rounded-full border-2 border-[#C8A96E]/30 border-t-[#C8A96E] animate-spin mx-auto mb-6" />
            <h2 className="text-white text-2xl font-light mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>Verificando...</h2>
            <p className="text-white/40 text-sm">Confirmando seu endereço de email.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#C8A96E]/10 mx-auto mb-6">
              <i className="ri-check-line text-[#C8A96E] text-3xl"></i>
            </div>
            <h2 className="text-white text-2xl font-semibold mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Email verificado!</h2>
            <p className="text-white/50 text-sm mb-8">Sua conta está ativa. Agora você pode fazer login.</p>
            <Link
              to="/auth"
              className="inline-block bg-[#C8A96E] text-[#0A0A0F] font-semibold px-8 py-3 rounded-xl hover:bg-[#D4B87A] transition-colors cursor-pointer"
            >
              Fazer login
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-red-500/10 mx-auto mb-6">
              <i className="ri-close-line text-red-400 text-3xl"></i>
            </div>
            <h2 className="text-white text-2xl font-semibold mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Verificação falhou</h2>
            <p className="text-white/50 text-sm mb-8">{errorMsg}</p>
            <Link to="/auth?mode=register" className="text-[#C8A96E] text-sm hover:underline cursor-pointer">
              Criar nova conta
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
